export default __webpack_public_path__ + "static/media/Shemite Mercenary Grips.912eae58.jpg";